import { ChangeEvent, useState } from 'react'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import toast from 'src/views/toast'
import handleError from 'src/utils/handleError'

type Props = {
  pathName: string
  forgotPassword: any
}

const CommonPasswordForgotPage = ({ pathName, forgotPassword }: Props) => {
  const [email, setEmail] = useState<string>('')

  const onEmailChange = () => (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const onRequestResetPassword = async () => {
    try {
      const response = await forgotPassword({
        email,
        redirectUrl: `${process.env.NEXT_PUBLIC_FRONT_URL}/${pathName}/password/edit`,
      })
      setEmail('')
      toast({
        type: 'success',
        message: response.message,
      })
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <>
      <Stack direction='row' alignItems='center' justifyContent='center' mb={4}>
        <Typography
          variant='h6'
          sx={{
            lineHeight: 1,
            fontWeight: 600,
            fontSize: '1.5rem !important',
          }}
        >
          パスワードリセット申請
        </Typography>
      </Stack>
      <Stack direction='column' justifyContent='center' alignItems='center'>
        <Typography variant='inherit' sx={{ mb: 2 }}>
          ご登録のメールアドレスを入力して下さい。
        </Typography>
        <form noValidate autoComplete='off' onSubmit={e => e.preventDefault()}>
          <TextField
            autoFocus
            fullWidth
            id='email'
            label='メールアドレス'
            value={email}
            sx={{ marginBottom: pathName === 'admin' ? 4 : 2 }}
            onChange={onEmailChange()}
          />
          <Button
            fullWidth
            size='large'
            variant='contained'
            sx={{ marginBottom: pathName === 'admin' ? 7 : 6 }}
            onClick={onRequestResetPassword}
            disabled={email.trim().length === 0}
            type='submit'
          >
            パスワード再設定を行う
          </Button>
        </form>
      </Stack>
    </>
  )
}

export default CommonPasswordForgotPage
